module.exports = __webpack_public_path__ + "img/fossilImg1.fa7df4f0.jpg";